import { HttpClient } from '@angular/common/http'
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Input, OnDestroy, OnInit, SecurityContext, ViewChild, DOCUMENT } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { IComponentDevOptions } from 'src/app/modules/dev/dev.page'
import { ConfigurationService } from 'src/app/services/configuration.service'
import { UtilityService } from 'src/app/services/utility.service'
import { environment } from 'src/environments/environment'
import { IExternalConfiguration } from './external.interface'

export const ExternalComponentDefaults: IExternalConfiguration = {
    type: 'external',
    display: true,
    id: '',
    includeCss: false
}

export const ExternalComponentDevOpts: IComponentDevOptions = {
    config: {
        ...ExternalComponentDefaults,
    },
}

@Component({
    selector: 'ras-external',
    template: `<div #vc></div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExternalComponent implements OnInit, OnDestroy {
    private $destroy = new Subject<void>()

    @ViewChild('vc') vc: ElementRef

    @Input() configuration: IExternalConfiguration

    constructor(
        private http: HttpClient,
        private configurationService: ConfigurationService,
        private sanitizer: DomSanitizer,
        private ref: ChangeDetectorRef,
        @Inject(DOCUMENT) private document: HTMLDocument
    ) {}

    ngOnInit(): void {
        UtilityService.populateConfigDefaults(this.configuration, ExternalComponentDefaults)
        const { id, includeCss } = this.configuration
        if (!id) {
            console.error(`ID is required for external component.`)
            return
        }
        const clientCode = this.configurationService.getConfig('catalog.client_code', '').toLowerCase()
        const timestamp = this.configurationService.getConfig('catalog.timestamp', '0')
        const headerPath = `${environment.data.assetsUrl}${clientCode}/components/${id}/`
        this.http.get(`${headerPath}${id}.html?v=${timestamp}`, {
            responseType: 'text',
        }).pipe(
            takeUntil(this.$destroy),
        ).subscribe((template) => {
            const safeHtml = this.sanitizer.sanitize(SecurityContext.HTML, template) ?? ''
            this.vc.nativeElement.innerHTML = safeHtml
            this.ref.markForCheck()
        })
        if (includeCss) {
            const link: HTMLLinkElement = this.document.createElement('link')
            link.setAttribute('rel', 'stylesheet')
            link.setAttribute('href', `${headerPath}styles.css?v=${timestamp}`)
            this.document.head.appendChild(link)
        }
    }

    ngOnDestroy(): void {
        this.$destroy?.next()
        this.$destroy?.complete()
    }
}
